import React from 'react';

const CommentCard = ({ comment, type = 'other', videoMetadata, aiAgentSettings }) => {
  if (!comment) return null;

  const getBorderColor = () => {
    switch (type) {
      case 'buyer':
        return 'border-green-500';
      case 'friction':
        return 'border-red-500';
      default:
        return 'border-gray-300';
    }
  };

  const getBackgroundColor = () => {
    switch (type) {
      case 'buyer':
        return 'bg-gradient-to-r from-green-50 to-white';
      case 'friction':
        return 'bg-gradient-to-r from-red-50 to-white';
      default:
        return 'bg-white';
    }
  };

  return (
    <div
      id={`comment-${comment.id}`}
      className={`bg-white rounded-xl p-5 mb-4 shadow-md transition-all hover:-translate-y-0.5 hover:shadow-lg border-l-4 ${getBorderColor()} ${getBackgroundColor()} relative`}
    >
      <div className="flex items-start gap-4">
        {comment.authorProfileImageUrl && (
          <img
            src={comment.authorProfileImageUrl}
            alt={comment.authorDisplayName || 'User'}
            className="w-10 h-10 rounded-full flex-shrink-0"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        )}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-2 flex-wrap">
            <h3 className="font-semibold text-gray-900 font-sans break-words">
              {comment.authorDisplayName || 'Anonymous'}
            </h3>
            {comment.publishedAt && (
              <span className="text-sm text-gray-500 whitespace-nowrap">
                {new Date(comment.publishedAt).toLocaleDateString()}
              </span>
            )}
          </div>
          <p className="text-gray-700 whitespace-pre-wrap font-sans break-words overflow-wrap-anywhere">
            {comment.textDisplay || comment.textOriginal || comment.text || 'No text'}
          </p>
          {comment.likeCount > 0 && (
            <div className="mt-2 text-sm text-gray-500">
              ­ƒæì {comment.likeCount} {comment.likeCount === 1 ? 'like' : 'likes'}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CommentCard;



